import bart from './bart'
import burns from './burns'
import maggie from './maggie'
import maggieMobile from './maggieMobile'
import mutuamas from './mutuamas'
import ecosistemas from './ecosistemas'
import mutua from './mutua'
import mutuamasMobile from './mutuamasMobile'
import driverPlus from './driverPlus'
import mutuamasOpe from './mutuamasOpe'

export default {
  bart,
  burns,
  maggie,
  maggieMobile,
  mutuamasMobile,
  ecosistemas,
  mutuamas,
  driverPlus,
  mutua,
  mutuamasOpe,
}
